import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const CreacionSalidaApi = () => {
    const [cargando, setCargando] = useState(false);

    const crearSalida = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("prod_bodega_salidas", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getExistenciasBodega = async (params) => {
        return api
            .get("prod_bodega_salidas/existencias", params)
            .then((data) => {
                if (data) return data;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getExistenciasSobranteBodega = async (params) => {
        return api
            .get("prod_bodega_salidas/existencias_sobrante", params)
            .then((data) => {
                if (data) return data;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getPalletsIngresadosDespues = async (params) => {
        return api
            .get("prod_bodega_salidas/pallets_ingresados_despues", params)
            .then((data) => {
                if (data) return data.pallets;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getAlmacenesReproceso = async (params) => {
        return api
            .get("prod_bodega_salidas/almacenes_reproceso", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    return {
        crearSalida,
        getExistenciasBodega,
        getExistenciasSobranteBodega,
        getPalletsIngresadosDespues,
        getAlmacenesReproceso,

        cargando,
    };
};
